import type { Trial, TrialSettings } from '@/model/entitlements/dto.generated';
import { TRIAL_URGENT_DAYS } from '@/shared/constants/trial';
import type { TrialSettingsView, TrialView } from '@/viewmodel/features/entitlements/types';

function dateOf(value: string | null | undefined): Date | null {
  if (!value) return null;
  const date = new Date(value);

  return Number.isNaN(date.getTime()) ? null : date;
}

export function toTrialView(trial: Trial | null | undefined): TrialView | null {
  if (!trial) return null;
  const expired = trial.expired === true;
  const started = expired || trial.started === true;
  const daysLeft = expired ? 0 : Math.max(trial.days_left ?? 0, 0);

  return {
    started,
    expired,
    endsAt: dateOf(trial.ends_at),
    daysLeft,
    urgent: started && !expired && daysLeft <= TRIAL_URGENT_DAYS,
  };
}

export function toTrialSettingsView(settings: TrialSettings | null): TrialSettingsView | null {
  return settings ? { days: settings.days, live: settings.live } : null;
}

export function planLabelKey(plan: string, onTrial: boolean): string {
  return onTrial && plan.toLowerCase() === 'free'
    ? 'workspaces.tier.freeTrial'
    : `workspaces.tier.${plan}`;
}

export function isTrialPlan(plan: string | undefined): boolean {
  const name = plan?.toLowerCase();

  return name === 'free' || name === 'trial-expired';
}
